export const AMBIENTE = {
  PRODUCAO: 1,
  HOMOLOGACAO: 2,
};

export const AMBIENTE_LABEL = {
  [AMBIENTE.PRODUCAO]: 'Produção',
  [AMBIENTE.HOMOLOGACAO]: 'Homologação',
};
